import { CartService } from '@/services/cart/CartService';

export default {
  install(Vue) {
    Vue.prototype.$cart = new CartService()
  }
}